"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useContactAvatarContext = exports.ContactAvatarContext = void 0;
var _reactUtils = require("@cian/react-utils");
const {
  useContext: useContactAvatarContext,
  Context: ContactAvatarContext
} = (0, _reactUtils.makeContextModule)({
  contextName: 'ContactAvatarContext',
  defaultValue: {
    size: 48
  }
});
exports.ContactAvatarContext = ContactAvatarContext;
exports.useContactAvatarContext = useContactAvatarContext;